import { ACCTNOSFX_INIT_SUCCESS, ACCTNOSFX_INIT_FAIL, ACCTNOSFX_INIT_LOADING } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [ACCTNOSFX_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [ACCTNOSFX_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [ACCTNOSFX_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async acctNoSfxManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.acctNoSfxManagement
    commit(ACCTNOSFX_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(ACCTNOSFX_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(ACCTNOSFX_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
